import { useEffect } from "react";
import { useAppDispatch } from "../store/hooks";
import { setThemeMode } from "../store/themeSlice";
import { useConfiguration } from "../hooks/useConfiguration";
import {
  useIsSharedTerminalWithoutEmployee,
  useSharedAccountInfo,
} from "../hooks/useSharedAccountInfo";
import type { ThemeMode } from "../lib/theme";

/**
 * Държи store-а на темата в синхрон с настройките от `/user/info`. Щом
 * потребителят се зареди (вход, refresh, ПИН на общ терминал), прилага
 * неговата тема. Без потребител:
 *  • ПИН екран на общ терминал → темата на ОБЩИЯ акаунт (терминала) от
 *    неговия `/user/info` (useSharedAccountInfo) — сменя се от бутона на
 *    самия ПИН екран; докато тя пътува, текущата тема остава (без мигане);
 *  • иначе (изход към /login без reload) → светлата, за да не остане чужда
 *    тема на екрана.
 * Монтира се веднъж, над router-а (main.tsx).
 */
export default function UserConfigurationSync() {
  const dispatch = useAppDispatch();
  const { configuration, isLoaded } = useConfiguration();
  const sharedTerminalWithoutEmployee = useIsSharedTerminalWithoutEmployee();
  const onPinScreen = !isLoaded && sharedTerminalWithoutEmployee;
  const shared = useSharedAccountInfo();

  let wanted: ThemeMode | null;
  if (isLoaded) wanted = configuration.theme;
  else if (!onPinScreen) wanted = "light";
  else if (shared.data) wanted = shared.data.configuration?.theme ?? "light";
  else wanted = null; // пътува или е паднала — не пипаме текущата

  // Реагира САМО на промяна на записаната тема (нов /user/info или сливане на
  // отговора на PUT), не на текущата в store-а — иначе оптимистичната смяна от
  // ThemeModal се връща веднага, докато PUT-ът още пътува (мигане).
  useEffect(() => {
    if (wanted) dispatch(setThemeMode(wanted));
  }, [wanted, dispatch]);

  return null;
}
